import React, { useRef, useState, useEffect } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import left from "../../assets/images/chevron-left.png";
import right from "../../assets/images/chevron-right.png";
import Servingdiverse from "./Servingdiverse";
import Popularproduct from "./Popularproduct";
import Customproduct from "./Customproduct";
import Reseller from "./Reseller";
import Constant from "../../utils/Constant";

// New LoadingSpinner component
const LoadingSpinner = () => {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.loadingSpinner}>
        <div style={{ ...styles.spinnerRing, ...styles.ring1 }}></div>
        <div style={{ ...styles.spinnerRing, ...styles.ring2 }}></div>
        <div style={{ ...styles.spinnerRing, ...styles.ring3 }}></div>
        <div style={styles.centerText}>Ziegler</div>
      </div>
    </div>
  );
};

const styles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    padding: "2rem",
    textAlign: "center",
    opacity: 0,
    animation: "fadeIn 0.4s ease-out forwards",
  },
  loadingSpinner: {
    position: "relative",
    width: "120px",
    height: "120px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinnerRing: {
    position: "absolute",
    width: "100%",
    height: "100%",
    border: "4px solid transparent",
    borderTop: "4px solid #099CD6",
    borderRadius: "50%",
    animation: "spin 1.2s linear infinite",
  },
  ring2: {
    width: "80%",
    height: "80%",
    top: "10%",
    left: "10%",
    borderTop: "4px solid #66b3e0",
    animationDelay: "-0.4s",
  },
  ring3: {
    width: "60%",
    height: "60%",
    top: "20%",
    left: "20%",
    borderTop: "4px solid #99cceb",
    animationDelay: "-0.8s",
  },
  centerText: {
    position: "relative",
    zIndex: 10,
    fontSize: "16px",
    fontWeight: "bold",
    color: "#099CD6",
  },
};

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderData, setSliderData] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);
  const [isSliderImageLoaded, setIsSliderImageLoaded] = useState(false);

  useEffect(() => {
    const fetchSliderData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${Constant.BASE_URL}/api/v1/home-slider`);
        const data = await response.json();

        if (data.status && data.data) {
          setSliderData(data.data);
        } else {
          throw new Error("Failed to fetch slider data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          setShowContent(true);
        }, 300);
      }
    };

    fetchSliderData();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsSliderImageLoaded(true);
    }, 5000);
  }, []);

  useEffect(() => {
    if (sliderData.length === 0) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) =>
        prev === sliderData.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(timer);
  }, [sliderData.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === sliderData.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? sliderData.length - 1 : prev - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      const scrollContainer = scrollRef.current;
      const items = scrollContainer.querySelectorAll(".logo-item");
      const clonedItems = Array.from(items).map((item) =>
        item.cloneNode(true)
      );
      clonedItems.forEach((item) => {
        item.classList.add("cloned");
        scrollContainer.appendChild(item);
      });
    }
  }, []);

  if (isLoading) {
    return (
      <>
        <Navbar />
        <LoadingSpinner />
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div className="error-container">
          <div className="error-content">
            <h2>Oops! Something went wrong</h2>
            <p>{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="retry-button"
            >
              Try Again
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      {!isSliderImageLoaded && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
          <LoadingSpinner />
        </div>
      )}

      <div
        className={`relative w-full flex flex-col items-center ${
          showContent ? "content-loaded" : "content-loading"
        }`}
      >
        <div className="relative w-full overflow-hidden slider-container">
          <div
            className="w-full h-full transition-transform duration-500 ease-out flex"
            style={{
              transform: `translateX(-${currentSlide * 100}%)`,
              width: `${sliderData.length * 100}%`,
            }}
          >
            {sliderData.map((slide, index) => (
              <div
                key={index}
                className="relative w-full h-full flex-shrink-0 slide-item"
              >
                <a
                  href={slide.slider_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={slide.slider_image}
                    alt={slide.slider_name}
                    onLoad={() => setIsSliderImageLoaded(true)}
                    className="slider-img w-screen max-h-[650px] object-cover block"
                  />
                </a>
              </div>
            ))}
          </div>

          {sliderData.length > 1 && (
            <>
              <button
                onClick={prevSlide}
                className="absolute lg:left-14 xsm:left-4 top-1/2 -translate-y-1/2 p-2 z-10 nav-button"
              >
                <img
                  src={left}
                  alt="Previous"
                  className="xl:w-[39px] xl:h-[40px] xsm:w-[22px] xsm:h-[22px] 2xl:w-[80px] 2xl:h-[80px]"
                />
              </button>
              <button
                onClick={nextSlide}
                className="absolute lg:right-14 xsm:right-4 top-1/2 -translate-y-1/2 p-2 z-10 nav-button"
              >
                <img
                  src={right}
                  alt="Next"
                  className="xl:w-[39px] xl:h-[40px] xsm:w-[22px] xsm:h-[22px] 2xl:w-[80px] 2xl:h-[80px]"
                />
              </button>

              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10 indicators-container">
                {sliderData.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`h-1 2xl:h-2 rounded-full transition-all duration-300 indicator ${
                      currentSlide === index
                        ? "xl:w-8 xsm:w-6 2xl:w-20 bg-gray-800"
                        : "xl:w-4 xsm:w-4 2xl:w-14 bg-gray-300"
                    }`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        <div className="sections-container">
          <Servingdiverse />
          <Popularproduct />
          <Customproduct />
          <Reseller />
        </div>
      </div>

      <Footer />

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .slider-img {
          image-rendering: auto;
          image-rendering: -webkit-optimize-contrast;
          image-rendering: -moz-crisp-edges;
          image-rendering: -o-crisp-edges;
          image-rendering: crisp-edges;
          -ms-interpolation-mode: nearest-neighbor;
          vertical-align: middle;
          box-sizing: border-box;
        }
      `}</style>
    </>
  );
};

export default Home;
